import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Wrapper from "@/timvir/wrapper";
const MDXLayout = Wrapper;
import {extendedWidth} from "timvir/core";
import {Exhibit, Grid, Code} from "timvir/blocks";
function _createMdxContent(props) {
  const _components = {
    h1: "h1",
    h3: "h3",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "TIP 0001"
    }), "\n", _jsx(_components.h3, {
      children: "Regular exhibit"
    }), "\n", _jsx(_components.p, {
      children: "An exhibit across the main column, usually used for mid-sized components."
    }), "\n", _jsx(Exhibit, {
      caption: "Caption",
      children: _jsx("div", {
        style: {
          background: "magenta",
          height: 100
        }
      })
    }), "\n", _jsx(_components.h3, {
      children: "Multiple exhibits in a grid"
    }), "\n", _jsx(_components.p, {
      children: "To showcase a small component in different variations, we often use Exhibit inside a Grid.\nOur Grid component places up to three items into a row (in the main column). Often the same\ncomponent is used in all grid items."
    }), "\n", _jsxs(Grid, {
      children: [_jsx(Exhibit, {
        caption: "Variant 1",
        children: _jsx("div", {
          style: {
            background: "magenta",
            height: 52
          }
        })
      }), _jsx(Exhibit, {
        caption: "Variant 2",
        children: _jsx("div", {
          style: {
            background: "magenta",
            height: 56
          }
        })
      }), _jsx(Exhibit, {
        caption: "Variant 3",
        children: _jsx("div", {
          style: {
            background: "magenta",
            height: 48
          }
        })
      }), _jsx(Exhibit, {
        caption: "Variant 4",
        children: _jsx("div", {
          style: {
            background: "magenta",
            height: 36
          }
        })
      }), _jsx(Exhibit, {
        caption: "Variant 5",
        children: _jsx("div", {
          style: {
            background: "magenta",
            height: 56
          }
        })
      })]
    }), "\n", _jsx(_components.h3, {
      children: "Exhibit with a small aspect ratio"
    }), "\n", _jsx(_components.p, {
      children: "Sometimes the content of the exhibit is taller than wide. This leaves space next to the exhibit\non the same row."
    }), "\n", _jsxs(Grid, {
      children: [_jsx(Exhibit, {
        children: _jsx("div", {
          style: {
            background: "magenta",
            height: 400
          }
        })
      }), _jsx("div", {
        style: {
          gridColumn: "2 / span 2"
        },
        children: _jsx(Code, {
          children: "Here Be Space"
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "This form could also make use of the extended width column to provide more space for both the exhibit and code."
    }), "\n", _jsxs(Grid, {
      className: extendedWidth,
      children: [_jsx(Exhibit, {
        children: _jsx("div", {
          style: {
            background: "magenta",
            height: 400
          }
        })
      }), _jsx("div", {
        style: {
          gridColumn: "2 / span 2"
        },
        children: _jsx(Code, {
          children: "Here Be Space"
        })
      })]
    }), "\n", _jsx("div", {
      style: {
        marginTop: 100
      }
    })]
  });
}
export default function MDXContent(props = {}) {
  return _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  });
}
